import { Unsubscribe } from 'redux';
import { getColumns } from './VariableBuilder.Grid';
import {
    resolveSystemVariableNameSuggestion, prepareOptionsFromVariables, dataTypeChangeMessage, prepareOptionsFromGlobalVariables,
    prepareVariables, findReferencedComponentsInVariables, prepareWarningMessageOnGlobalVariableAdd, addCurentGlobalLookupNumbersToMap
} from './VariableBuilder.Helpers';
import AssignmentBuilder from '../../Functions/Assignment/AssignmentBuilder';
import assignmentHelper from '../../../infrastructure/helpers/functions/assignment/assignmentHelper';
import DeclarationBuilderProps from '../../Functions/Declaration/DeclarationBuilderProps';
import ErrorList from '../../Common/ErrorList/ErrorList';
import locationType from '../../../types/functions/Location/LocationType';
import pseudocodeHelper from '../../../infrastructure/helpers/functions/common/pseudocodeHelper';
import React from 'react';
import store from '../../../store/store';
import actions from '../../../store/actions';
import reportConfigNavigation from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import ReportLogicLocation from '../../../types/functions/Location/ReportLogicLocation';
import reportLogicReferenceHelper from '../../../infrastructure/helpers/functions/report/reportLogicReferenceHelper';
import ReportVariable from '../../../types/report/ReportVariable';
import SelectOption from '../../../infrastructure/types/SelectOption';
import systemVariables from '../../../infrastructure/constants/functions/systemVariables';
import CopyVariableModalState from './CopyVariableModal/CopyVariableModalState';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import dataType from '../../../infrastructure/constants/dataType';
import { mapToBasicOption } from '../../../infrastructure/helpers/html/selectOptionHelper';
import reorderHelper from '../../../infrastructure/helpers/common/reorderHelper';
import Assignment from '../../../types/functions/Assignment/Assignment';
import Operand from '../../../types/functions/Operand/Operand';
import ReportConfigComponentLock from '../../../types/report/ReportConfigComponentLock';
import { getConfirmRemoveMessage } from '../../Functions/Assignment/AssignmentItem/AssignmentItem.Helpers';
import IdNameAndNumber from '../../../types/report/IdNameAndNumber';
import reportComponentBuildersHelper from '../Common/ReportComponentsHelper';
import ComponentType from '../../../types/report/ComponentType';
import ActionType from '../../../types/report/ActionType';
import { reportType } from '../../../infrastructure/constants/reportType';
import WarningModal from '../../Common/Modals/WarningModal/WarningModal';
import { onReferenceSelected } from '../../../infrastructure/helpers/report/reference/helper';
import ReportComponentStatus from '../Common/ReportComponentStatus/ReportComponentStatus';
import DragAndDropItem from '../../../types/report/DragAndDropItem';
import Mode from '../../../types/report/Mode';
import AddComponentWithGlobalOptionsPopup from '../GlobalModule/AddComponentWithGlobalOptionsPopup';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import Lookup from '../../../types/functions/Lookup';
import { prepareLookups, updateLookupToLookupReferences } from '../Lookup/LookupBuilder.Helpers';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import IdAndType from '../../../types/report/IdAndType';
import UserDefinedFunction from '../../../types/report/UserDefinedFunction';
import { prepareFunctions, updateReportComponentToFunctionAssignment, updateReportComponentToFunctionCondition } from '../UserDefinedFunctions/UserDefinedFunctionSelector/UserDefinedFunction.Helpers';
import { prepareRefDataSourcesForConfig } from '../Pages/ReportPage/ReportPage.Helpers';
import { htmlIds } from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation.HtmlIds';
import { buildText, onGlobalComponentLinkClick, prepareComponentType } from '../Common/ReferenceComponentHelper/ReferenceComponentHelper';
import NameAndNumber from '../../../types/report/NameAndNumber';
import ReportLogicListWithPaging from '../Common/ReportLogicList/ReportLogicListWithPaging';
import SearchByFor from '../../Common/AutocompleteInput/SearchByFor';
import SearchByType from '../../../types/report/SearchByType';
import Component from '../../../types/common/Component';
import CustomDropdownOption from '../../Common/Dropdown/CustomDropdownOption';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import ReportConfigNavigationPayload from '../../../types/report/ReportConfigNavigationPayload';
import ReportLogicList from '../Common/ReportLogicList/ReportLogicList';
import domNavigationHelper from '../../../infrastructure/helpers/html/domNavigationHelper';

const dataTypeOptions = Object.values(dataType).map(mapToBasicOption);

interface State {
    showInsertAtPositionModal: boolean,
    error: string,
    dataType: string,
    number: number,
    assignment: Assignment,
    showWarningModal: boolean,
    location: ReportLogicLocation,
    variable: ReportVariable,
    isSingle?: boolean,
    event?: React.MouseEvent<HTMLElement>,
    reportConfigComponentLock?: ReportConfigComponentLock,
    message: string,
    title: string,
    onWarningOkClickFunction: () => void,
    showGlobalVariableReferencesPopup: boolean,
    globalVariableId: number,
    globalVariableWarningMessage: string,
    missingDataSources: Map<number, string>,
    missingLookups: Lookup[],
    missingFunctions: UserDefinedFunction[],
    missingVariables: ReportVariable[],
    globalVariableName: string,
    isDataTypeSelectionDisabled: boolean,
    selecteDataType: string | undefined,
    useGlobalData: boolean,
    items: ReportVariable[],
    refresh: boolean,
    navigateTo: string,
    showLastPage: boolean,
    searchBy: string;
}

interface Props extends DeclarationBuilderProps<ReportVariable> {
    expandSection: () => void;
}

class VariableBuilder extends React.Component<Props, State> {
    private unsubscribeCopyVariable: Unsubscribe | undefined;
    private unsubscribeComponentChange: Unsubscribe | undefined;
    private unsubscribeReferenceSelected: Unsubscribe | undefined;
    private unsubscribeNavigateTo: Unsubscribe | undefined;
    private unsubscribeNavigatedTo: Unsubscribe | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            showInsertAtPositionModal: false,
            error: '',
            dataType: '',
            number: 0,
            assignment: {} as Assignment,
            showWarningModal: false,
            location: {} as ReportLogicLocation,
            variable: {} as ReportVariable,
            isSingle: false,
            event: undefined,
            reportConfigComponentLock: {} as ReportConfigComponentLock,
            message: '',
            title: '',
            onWarningOkClickFunction: () => { },
            showGlobalVariableReferencesPopup: false,
            globalVariableId: 0,
            globalVariableWarningMessage: '',
            missingDataSources: new Map<number, string>(),
            missingLookups: [],
            missingFunctions: [],
            missingVariables: [],
            globalVariableName: '',
            isDataTypeSelectionDisabled: false,
            selecteDataType: undefined,
            useGlobalData: false,
            items: [],
            refresh: false,
            navigateTo: '',
            showLastPage: false,
            searchBy: ''
        }

        this.onNameChange = this.onNameChange.bind(this);
        this.onDataTypeChange = this.onDataTypeChange.bind(this);
        this.onBusinessDescriptionChange = this.onBusinessDescriptionChange.bind(this);
        this.onIsSystemChange = this.onIsSystemChange.bind(this);
        this.onAddVariableClick = this.onAddVariableClick.bind(this);
        this.onRemoveVariableClick = this.onRemoveVariableClick.bind(this);
        this.onResetAssignmentClick = this.onResetAssignmentClick.bind(this);
        this.getVariableReferences = this.getVariableReferences.bind(this);
        this.getAssignmentContent = this.getAssignmentContent.bind(this);
        this.onCopyVariableClick = this.onCopyVariableClick.bind(this);
        this.onCopyVariableSave = this.onCopyVariableSave.bind(this);
        this.reorder = this.reorder.bind(this);
        this.onVariableConfiguredInPopup = this.onVariableConfiguredInPopup.bind(this);
        this.tryLock = this.tryLock.bind(this);
        this.onDataTypeChangeClick = this.onDataTypeChangeClick.bind(this);
        this.onRemoveAssignmentConfirmed = this.onRemoveAssignmentConfirmed.bind(this);
        this.onGlobalVariableLinkClick = this.onGlobalVariableLinkClick.bind(this);
        this.onGlobalModeInPopupChange = this.onGlobalModeInPopupChange.bind(this);
        this.getDataTypeOptions = this.getDataTypeOptions.bind(this);
        this.onDropBetweenVariables = this.onDropBetweenVariables.bind(this);
        this.onReferenceSelected = this.onReferenceSelected.bind(this);
        this.onGlobalVariableModeClick = this.onGlobalVariableModeClick.bind(this);
        this.onComponentChange = this.onComponentChange.bind(this);
        this.onVariableReferenceSelected = this.onVariableReferenceSelected.bind(this);
        this.onReferenceNavigatedTo = this.onReferenceNavigatedTo.bind(this);
        this.onSearchBySelected = this.onSearchBySelected.bind(this);
        this.onMainNavigationStepClick = this.onMainNavigationStepClick.bind(this);
    }

    componentDidMount(): void {

        this.unsubscribeCopyVariable = store.subscribe(this.onCopyVariableSave);
        this.unsubscribeComponentChange = store.subscribe(this.onComponentChange);
        this.unsubscribeReferenceSelected = store.subscribe(this.onVariableReferenceSelected);
        this.unsubscribeNavigateTo = store.subscribe(this.onMainNavigationStepClick);
        this.unsubscribeNavigatedTo = store.subscribe(this.onReferenceNavigatedTo);
        this.setInternalIds();
        this.setVariableReadonly();

        this.setState({ items: copyArray(this.props.reportConfig.variables) });
    }

    onMainNavigationStepClick() {
        let appState = store.getState();

        if (appState.action !== actions.navigation.mainNavigation) {
            return;
        }

        if (appState.mainNavigation.location?.statement === locationType.statement.variable) {
            store.dispatch({
                type: actions.navigation.expand, payload: {
                    expandHtmlId: htmlIds.variables
                } as ReportConfigNavigationPayload
            });

            if (this.props.reportConfig.type === reportType.accuracy) {

                let items = copyArray(this.props.reportConfig.variables);

                this.setState({ navigateTo: appState.mainNavigation.details.definitionHtmlId as string, items, refresh: true });
            }
            else {
                domNavigationHelper.navigate(appState.mainNavigation.details.definitionHtmlId as string);
            }
        }
    }

    onVariableReferenceSelected() {
        let appState = store.getState();

        if (appState.action !== actions.reference.selected) {
            return;
        }

        let stateProperties = appState.navigateToReportConfigSection;

        if (stateProperties.expandHtmlId.split('-').includes(htmlIds.variables)) {

            store.dispatch({
                type: actions.navigation.expand, payload: {
                    expandHtmlId: htmlIds.variables
                } as ReportConfigNavigationPayload
            });

            if (this.props.reportConfig.type === reportType.accuracy) {

                let number = parseInt(stateProperties.scrollToHtmlId.split('-')[1]);

                let items = copyArray(this.props.reportConfig.variables).filter(x => x.number === number);

                this.setState({ navigateTo: stateProperties.scrollToHtmlId, items, refresh: true });
            }
            else {
                domNavigationHelper.navigate(stateProperties.scrollToHtmlId);
            }
        }
    }

    onComponentChange() {
        let appState = store.getState();

        if (appState.action !== actions.component.change) {
            return;
        }

        let items = copyArray(this.props.reportConfig.variables);

        if (appState.componentChange?.location?.statement === locationType.statement.variable) {

            if (appState.componentChange?.actionType === ActionType.Add) {

                let number = appState.componentChange.location.statementNumber;

                let htmlId = reportConfigNavigation.buildVariableId(number);

                this.setState({ navigateTo: htmlId, items, refresh: true });
            }
            else if (appState.componentChange?.actionType === ActionType.Remove) {
                this.setState({ navigateTo: '', items, refresh: true });
            }
            else {
                let variables = [] as ReportVariable[];

                this.state.items.forEach((v) => {
                    let varInProps = this.props.reportConfig.variables.find(x => x.number === v.number);

                    if (varInProps) {
                        variables.push(copyObject(varInProps));
                    }
                });

                this.setState({ items: variables, refresh: false, navigateTo: '' });
            }
        }
    }

    setInternalIds() {
        let index = 1;
        this.props.reportConfig.variables.forEach((variable) => {
            variable._internalId = index;
            index += 1;
        })
    }

    componentDidUpdate(prevProps: DeclarationBuilderProps<ReportVariable>) {
        if (!this.state.refresh) {
            if (this.props.reportConfig.variables !== prevProps.reportConfig.variables || prevProps.reportConfig.variables.length !== this.props.reportConfig.variables.length) {
                if (this.props.reportConfig.variables.length > prevProps.reportConfig.variables.length ||
                    this.props.reportConfig.variables.length < prevProps.reportConfig.variables.length) {

                    this.setState({ navigateTo: '', items: copyArray(this.props.reportConfig.variables), refresh: false });
                }
                else {
                    this.setState({ items: copyArray(this.props.reportConfig.variables), refresh: false });
                }
            }
        }
    }

    componentWillUnmount(): void {

        (this.unsubscribeCopyVariable as Unsubscribe)();
        (this.unsubscribeComponentChange as Unsubscribe)();
        (this.unsubscribeReferenceSelected as Unsubscribe)();
        (this.unsubscribeNavigatedTo as Unsubscribe)();
        (this.unsubscribeNavigateTo as Unsubscribe)();
    }

    onReferenceNavigatedTo() {

        let appState = store.getState();

        if (appState.action !== actions.reference.navigated) {
            return;
        }

        this.setState({ navigateTo: '' });
    }

    async onNameChange(name: string, number: number) {

        const isLocked = await this.tryLock(number);

        if (!isLocked) {
            let location = this.getLocation(number);
            this.props.onDeclarationChange(location, { name: name || '' } as ReportVariable);
        }
    }

    onDataTypeChangeClick(dataType: string, number: number, assignment: Assignment) {
        this.setState({ dataType, number, assignment, showWarningModal: true, message: dataTypeChangeMessage, title: 'Data type change', onWarningOkClickFunction: this.onDataTypeChange });
    }

    onDataTypeChange(): void {

        this.setState({ showWarningModal: false });

        let location = this.getLocation(this.state.number);
        let changes = {} as ReportVariable;

        let error = this.props.validateRemoveDeclaration(location);
        if (error) {
            changes.errors = [error];
        }
        else {
            changes.dataType = this.state.dataType;
            changes.assignment = assignmentHelper.removeOnlyValues(false, this.state.assignment);
            changes.assignment.number = this.state.assignment.number;
        }

        this.props.onDeclarationChange(location, changes);
    }

    async onBusinessDescriptionChange(businessDescription: string, number: number): Promise<void> {
        const isLocked = await this.tryLock(number);
        if (!isLocked) {
            let location = this.getLocation(number);
            this.props.onDeclarationChange(location, { businessDescription: businessDescription } as ReportVariable);
        }
    }

    setVariableReadonly() {
        this.props.reportConfig.variables.forEach((variable: ReportVariable) => {
            variable.isReadOnly = variable.mode === Mode.Global;
        });
    }

    async onIsSystemChange(isSystem: boolean, dataType: string, number: number, event: React.ChangeEvent<HTMLElement>): Promise<void> {

        const isLocked = await this.tryLock(number);

        if (!isLocked) {
            let error: string | null = null;
            let location = this.getLocation(number);
            let overrideDataType = isSystem && dataType !== systemVariables.dataType;
            if (overrideDataType) {
                error = this.props.validateRemoveDeclaration(location);
            }

            let changes = {} as ReportVariable;

            if (error) {
                changes.errors = [error];
            }
            else {
                changes.isSystem = isSystem;
                if (isSystem) {
                    changes.name = resolveSystemVariableNameSuggestion(this.props.reportConfig.variables);
                }
                if (overrideDataType) {
                    changes.dataType = systemVariables.dataType;
                    changes.assignment = assignmentHelper.getEmpty(false);
                    changes.assignment.number = 1;
                }
            }

            this.props.onDeclarationChange(location, changes);
        }
    }

    onAddVariableClick(): void {
        this.setState({ showInsertAtPositionModal: true });
    }

    async onVariableConfiguredInPopup(name: string, type: string, isInsertAfter: boolean, selectedVariableNumber: string, globalVariableModuleId: number | undefined): Promise<void> {

        this.setState({ showInsertAtPositionModal: false });

        const insertionNumber: number = parseInt(selectedVariableNumber);

        let location = this.getLocation(insertionNumber);

        this.props.onAddDeclarationClick((variable: ReportVariable, variables: ReportVariable[]) => {

            variables = reorderHelper.rearangeElementsWhenAddNewOne(variables, variable, isInsertAfter, insertionNumber) as ReportVariable[];

            if (!name) {
                variable.name = `var-${variable.number}`;
                variable._internalId = variable.number;
            }
            else {
                variable.name = name
            }

            if (globalVariableModuleId) {

                let globalVariable = this.props.collections.globalModuleConfig.variables.find(x => x.id === globalVariableModuleId) as ReportVariable;

                variable.mode = Mode.Global;

                variable.isReadOnly = true;

                variable.isSystem = globalVariable?.isSystem || false;

                variable.globalVariableModuleId = globalVariableModuleId;

                variable.businessDescription = globalVariable?.businessDescription || '';

                variable.name = !name ? globalVariable.name : variable.name;

                variable.dataType = globalVariable.dataType;

                this.proceedWithGlobalVariableReferences(globalVariable, variable);
            }
            else {
                variable.mode = Mode.Local;
                variable.dataType = type || dataType.boolean;

                reorderHelper.changeReferences(this.props.reportConfig,
                    variables, (operand: Operand, oldAndNewNumbers: Map<number, number>, componentType: ComponentType | undefined) => {
                        if (componentType !== ComponentType.AccuracyValidation) {
                            if (operand.variableNumber && oldAndNewNumbers.has(operand.variableNumber)) {
                                operand.variableNumber = oldAndNewNumbers.get(operand.variableNumber) as number;
                            }
                        }
                    }
                );
            }
        }, undefined, undefined, location);
    }

    proceedWithGlobalVariableReferences(globalVariable: ReportVariable, variable: ReportVariable) {

        let dataSourcesIds = new Set<number>();

        let referencedVariables: ReportVariable[] = [];

        let referencedLookups: Lookup[] = [];

        let referencedFunctions: UserDefinedFunction[] = [];

        let missingDataSourcesMap = new Map<number, string>();

        findReferencedComponentsInVariables(this.props.collections.globalModuleConfig,
            this.props.reportConfig,
            variable.globalVariableModuleId as number,
            dataSourcesIds,
            referencedLookups,
            referencedVariables,
            referencedFunctions,
            missingDataSourcesMap);

        let reportConfigFunctionsIds = this.props.reportConfig.userDefinedFunctions.filter(x => x.mode === Mode.Global && x.globalUDFModuleId).map(x => x.id);

        let missingFunctions = referencedFunctions.filter(x => x.id && !reportConfigFunctionsIds.includes(x.id as number));

        let reportConfigVariablesIds = this.props.reportConfig.variables.filter(x => x.mode === Mode.Global && x.globalVariableModuleId).map(x => x.id);

        let missingVariables = referencedVariables.filter(x => x.id && !reportConfigVariablesIds.includes(x.id as number));

        let reportConfigLookupsIds = this.props.reportConfig.lookups.filter(x => x.mode === Mode.Global && x.globalLookupModuleId).map(x => x.id);

        let missingLookups = referencedLookups.filter(x => x.id && !reportConfigLookupsIds.includes(x.id as number));

        this.setState({
            globalVariableId: variable.globalVariableModuleId as number,
            missingDataSources: missingDataSourcesMap,
            missingLookups,
            missingFunctions,
            missingVariables,
            globalVariableName: variable.name
        });

        if (missingDataSourcesMap.size > 0 || referencedFunctions.length > 0 || referencedLookups.length > 0 || referencedVariables.length > 0) {

            let errorMessage = prepareWarningMessageOnGlobalVariableAdd(missingDataSourcesMap, referencedLookups, referencedVariables, referencedFunctions);

            errorMessage += `
                Click "Ok" if you want them to be added automatically for you.

                Click "Cancel" to add them manually.`;

            this.setState({
                globalVariableWarningMessage: errorMessage,
                showGlobalVariableReferencesPopup: true,
                showInsertAtPositionModal: false
            });
        }
        else {

            variable.assignment = copyObject(globalVariable.assignment);
            updateReportComponentToFunctionAssignment(variable.assignment, this.props.collections.globalModuleConfig.userDefinedFunctions);

            this.setState({ showInsertAtPositionModal: false, globalVariableName: '' });
        }
    }

    createVariableIdAndNumber(): Map<number, number> {
        const variablesIdAndNumber = new Map<number, number>();

        this.props.reportConfig.variables.forEach((variable) => {
            const id = variable._internalId;
            variablesIdAndNumber.set(id, variable.number);
        });

        return variablesIdAndNumber;
    }

    async onRemoveVariableClick(number: number, event: React.MouseEvent<HTMLElement>): Promise<void> {

        let location = this.getLocation(number);

        const isLocked = await this.tryLock(number);

        let componentId = undefined;

        if (this.props.reportConfig.type === reportType.globalModule) {
            componentId = this.props.reportConfig.variables.find(x => x.number === number)?.id || undefined;
        }

        if (!isLocked) {
            const validationError = await reportComponentBuildersHelper.validateAction(
                number,
                false,
                this.props.reportConfig.variables as IdNameAndNumber[],
                ComponentType.Variable,
                ActionType.Remove,
                this.props.reportConfig,
                componentId);

            if (!validationError) {
                this.props.onRemoveDeclarationClick(location, (variables) => {

                    let updated = reorderHelper.rearangeElementsWhenRemoveOne(variables) as ReportVariable[];

                    reorderHelper.changeReferences(
                        this.props.reportConfig,
                        updated,
                        (operand: Operand, oldAndNewNumbers: Map<number, number>) => {
                            if (operand.variableNumber && oldAndNewNumbers.has(operand.variableNumber)) {
                                operand.variableNumber = oldAndNewNumbers.get(operand.variableNumber) as number;
                            }
                        }
                    );
                });
            }
            else {
                this.props.onRemoveDeclarationClick(location, undefined, undefined, validationError);
            }
        }
    }

    async onRemoveAssignmentClick(location: ReportLogicLocation, variable: ReportVariable, isSingle?: boolean, event?: React.MouseEvent<HTMLElement>, reportConfigComponentLock?: ReportConfigComponentLock): Promise<void> {
        const isLocked = await this.tryLock(undefined, variable);

        if (!isLocked) {
            this.setState({ message: getConfirmRemoveMessage(isSingle || false), isSingle, variable, location, reportConfigComponentLock, showWarningModal: true, title: 'Remove assignment', onWarningOkClickFunction: this.onRemoveAssignmentConfirmed });
        }
    }

    onRemoveAssignmentConfirmed() {

        this.setState({ showWarningModal: false });

        this.props.onRemoveAssignmentClick(this.state.location, this.state.isSingle, this.state.event, this.state.reportConfigComponentLock);
    }

    async onResetAssignmentClick(location: ReportLogicLocation, variable: ReportVariable, isSingle?: boolean, event?: React.MouseEvent<HTMLElement>, reportConfigComponentLock?: ReportConfigComponentLock): Promise<void> {

        const isLocked = await this.tryLock(undefined, variable);

        if (!isLocked) {
            this.props.onResetAssignmentClick(location, false, event, reportConfigComponentLock);
        }
    }

    getLocation(number: number): ReportLogicLocation {

        return { statement: locationType.statement.variable, statementNumber: number } as ReportLogicLocation;
    }

    async getVariableReferences(number: number): Promise<CustomDropdownOption[]> {

        let config = copyObject(this.props.reportConfig);

        config.variables = config.variables.filter(x => x.number !== number);

        let references = reportLogicReferenceHelper.getVariableReferences(number, this.props.reportConfig, this.props.collections);

        let options: CustomDropdownOption[] = references.map((x) => { return { component: { htmlId: x.value, name: x.text, componentType: x.componentType, componentNumber: x.number, reportConfigId: x.configId, componentInnerType: x.innerType, mainComponentNumber: x.mainComponentNumber } as Component } as CustomDropdownOption });

        if (this.props.reportConfig.type === reportType.globalModule) {
            let variable = this.props.reportConfig.variables.find(x => x.number === number);

            if (variable?.id) {

                let component = { componentInnerType: ComponentType.Variable, componentType: ComponentType.Variable, componentId: variable?.id, reportConfigId: config.id, componentNumber: variable?.number } as Component;

                let res = await httpClient.post('report/global-module/references', component);

                let refs = res.data as Component[];

                refs.forEach((ref) => {
                    ref.name = buildText(ref.reportConfigName || '', ref.name || '', ref.componentType);
                    options.push({
                        component: ref,
                        asUrl: true
                    } as CustomDropdownOption)
                });
            }
        }

        return options;
    }

    setVariableName(variable: ReportVariable): void {

        variable.name = `var-${variable.number}`;
    }

    async onCopyVariableClick(number: number, event: React.MouseEvent<HTMLElement>): Promise<void> {

        const isLocked = await this.tryLock(number);

        if (!isLocked) {
            let state: CopyVariableModalState = {
                title: 'Copy Variable',
                isOpen: true,
                error: null,
                sourceVariableNumber: number.toString(),
                targetVariableNumber: '',
                toVariables: []
            };

            store.dispatch({ type: actions.copyVariableModal.change, payload: state });
        }
    }

    onCopyVariableSave(): void {

        let appState = store.getState();

        if (appState.action !== actions.copyVariableModal.save) {
            return;
        }

        let sourceNumber = parseInt(appState.copyVariableModalSave.sourceVariableNumber);
        let sourceVariable = this.props.reportConfig.variables.find(x => x.number === sourceNumber) as ReportVariable;

        let targetNumber = parseInt(appState.copyVariableModalSave.targetVariableNumber);
        let targetVariable = this.props.reportConfig.variables.find(x => x.number === targetNumber) as ReportVariable;

        targetVariable.assignment = copyObject(sourceVariable.assignment);
        targetVariable.businessDescription = sourceVariable.businessDescription;

        let location = this.getLocation(targetVariable.number);
        this.props.onDeclarationChange(location, targetVariable);
    }

    async reorder(dragNumber: number, dropNumber: number, event: React.DragEvent<HTMLDivElement>): Promise<void> {

        const isLockedDragged = await this.tryLock(dragNumber);
        let isLockedDropped = false;
        if (!isLockedDragged) {
            isLockedDropped = await this.tryLock(dropNumber);
        }

        if (!isLockedDragged && !isLockedDropped) {
            let dragIndex = this.props.reportConfig.variables.findIndex(x => x.number === dragNumber);
            let dropIndex = this.props.reportConfig.variables.findIndex(x => x.number === dropNumber);

            let draggedVariable = this.props.reportConfig.variables.find(v => v.number === dragNumber) as ReportVariable;
            let dropVariable = this.props.reportConfig.variables.find(v => v.number === dropNumber) as ReportVariable;

            this.clearAllErrors();

            let result = reportComponentBuildersHelper.validateDragAndDrop(draggedVariable as DragAndDropItem, dropVariable as DragAndDropItem, ComponentType.Variable);

            let changes = {} as ReportVariable;

            if (result.error) {
                const variableReferenced: ReportVariable = this.props.reportConfig.variables.find(s => s.number === result.number) || {} as ReportVariable;

                result.error = `${result.error} The referenced variable is "${variableReferenced.name}".`;

                changes.errors = [result.error];

                this.props.onDeclarationChange(this.getLocation(result.isDrag ? dragNumber : dropNumber), changes);

                return;
            }
            else {

                reorderHelper.reorderWithNumbersChange(this.props.reportConfig.variables, dragIndex, dropIndex);

                reorderHelper.changeReferences(this.props.reportConfig,
                    this.props.reportConfig.variables, (operand: Operand, oldAndNewNumbers: Map<number, number>, componentType?: ComponentType | undefined) => {
                        if (componentType !== ComponentType.AccuracyValidation) {
                            if (operand.variableNumber && operand.variableNumber === draggedVariable.number) {
                                operand.variableNumber = dropVariable.number;
                            }
                            else if (operand.variableNumber && operand.variableNumber === dropVariable.number) {
                                operand.variableNumber = draggedVariable.number;
                            }
                        }
                    }
                );

                let loc = this.getLocation(result.isDrag ? dragNumber : dropNumber);

                this.props.onDragAndDrop && this.props.onDragAndDrop(this.props.reportConfig.variables, loc);
            }
        }
    }

    clearAllErrors() {
        this.props.reportConfig.variables.forEach((variable) => {
            variable.errors = [];
        });
    }

    async tryLock(number?: number, variable?: ReportVariable): Promise<boolean> {

        let isLocked = false;
        if (this.props.reportConfig.type === reportType.accuracy && this.props.onComponentContainerClick) {

            let currentvariable = variable || this.props.reportConfig.variables.find(v => v.number === number);
            if (!currentvariable?.isUsedByCurrentUser) {
                isLocked = await this.props.onComponentContainerClick({ componentId: currentvariable?.id || 0, componentType: ComponentType.Variable, number: currentvariable?.number || 0 });
            }
        }
        return isLocked;
    }

    async onReorderConditions(variable: ReportVariable, error?: string) {
        let isLocked = await this.tryLock(variable.number);

        if (error && !variable.errors.includes(error)) {
            variable.errors.push(error);
        }
        if (!isLocked) {
            let location = this.getLocation(variable.number);
            this.props.onDeclarationChange(location, variable);
        }
    }

    async onClearClick(location: ReportLogicLocation, variable: ReportVariable, conditionNumber: number, isValue?: boolean): Promise<boolean> {

        let isLocked = await this.tryLock(undefined, variable);

        if (!isLocked) {
            let newVariable = assignmentHelper.clearOperandsInDeclaration(location, variable, conditionNumber, isValue) as ReportVariable;

            this.props.onDeclarationChange(location, newVariable);
        }
        return isLocked;
    }

    getAssignmentContent(variable: ReportVariable): JSX.Element {
        const reportConfigComponentLock: ReportConfigComponentLock = { componentId: variable.id || 0, componentType: ComponentType.Variable, number: variable.number };

        let dataSources = this.props.collections.dataSources;

        if (variable.mode === Mode.Global) {
            dataSources = [];
            this.props.collections.globalModuleConfig.refDataSources.forEach((ds) => {
                dataSources.push({ fieldDefinitions: ds.fieldDefinitions, id: ds.id, dataSourceKind: ds.dataSouceKind as string, name: ds.name as string } as IngestionConfig);
            })
        }

        return (
            <>
                <AssignmentBuilder
                    reportConfigType={this.props.reportConfig.type}
                    isReadOnly={variable.isReadOnly || this.props.isReadOnly}
                    location={this.getLocation(variable.number)}
                    assignment={variable.assignment}
                    fieldName={pseudocodeHelper.wrapInBrackets(variable.name)}
                    functions={this.props.reportConfig.userDefinedFunctions}
                    globalFunctions={this.props.collections.globalModuleConfig.userDefinedFunctions}
                    lookups={this.props.reportConfig.lookups}
                    dictionaries={this.props.reportConfig.dictionaries}
                    variables={this.props.reportConfig.variables}
                    dataSources={dataSources}
                    reportFields={this.props.collections.reportFields}
                    customDataSourceFields={this.props.collections.customDataSourceFields}
                    onAddAssignmentClick={(location, event) => this.props.onAddAssignmentClick(location, event, reportConfigComponentLock)}
                    onRemoveAssignmentClick={(location, isSingle, event) => this.onRemoveAssignmentClick(location, variable, isSingle, event, reportConfigComponentLock)}
                    onResetAssignmentClick={(location, isSingle, event) => { this.onResetAssignmentClick(location, variable, isSingle, event, reportConfigComponentLock) }}
                    onLogicalOperatorChange={(location, operator, event) => this.props.onLogicalOperatorChange(location, operator, event, reportConfigComponentLock)}
                    onParenthesesChange={(location, count, type, event) => this.props.onParenthesesChange(location, count, type, event, reportConfigComponentLock)}
                    onAddConditionClick={(location, operator, event) => this.props.onAddConditionClick(location, operator, event, reportConfigComponentLock)}
                    onRemoveConditionClick={(location, event) => this.props.onRemoveConditionClick(location, event, reportConfigComponentLock)}
                    onComparisonTypeChange={(location, value, event) => this.props.onComparisonTypeChange(location, value, event, reportConfigComponentLock)}
                    onOperandClick={(location, event) => this.props.onOperandClick(location, event, reportConfigComponentLock)}
                    onCopyClick={(location) => this.props.onCopyClick(location, reportConfigComponentLock)}
                    onPasteClick={(location, event) => this.props.onPasteClick(location, event, reportConfigComponentLock)}
                    onValidateFieldClick={(location, event) => this.props.onValidateDeclarationClick(location, event, reportConfigComponentLock)}
                    onClearClick={(location: ReportLogicLocation, conditionNumber: number, isValue?: boolean) => this.onClearClick(location, variable, conditionNumber, isValue)}
                    allowPaste={this.props.allowPaste}
                    key={variable.number}
                    onReorderAssignmentConditions={(error) => { this.onReorderConditions(variable, error); }}
                />

                <ErrorList errors={variable.errors} className="mt-2" />

                <ReportComponentStatus
                    reportType={this.props.reportConfig.type}
                    lastUpdatedTime={variable.lastUpdatedTime}
                    isReadOnly={this.props.isReadOnly} />
            </>
        );
    }

    addDataSourcesAndMissingComponents() {

        this.setState({
            useGlobalData: true
        });
        let refDataSources = prepareRefDataSourcesForConfig(this.props.collections.globalModuleDataSources, this.props.collections.dataSources, this.state.missingDataSources, this.props.reportConfig);

        let lookupsOldAndNewNumbers = new Map<number, number>();

        let lookups = prepareLookups(this.state.missingLookups, this.props.reportConfig, undefined, lookupsOldAndNewNumbers);

        let missingVariables = copyArray(this.state.missingVariables);

        let mainVariable = this.props.collections.globalModuleConfig.variables.find(x => x.id === this.state.globalVariableId) as ReportVariable;

        let globalLookupsInCurrentConfig = this.props.reportConfig.lookups.filter(x => x.mode === Mode.Global);

        if (globalLookupsInCurrentConfig.length) {
            addCurentGlobalLookupNumbersToMap(globalLookupsInCurrentConfig, this.props.collections.globalModuleConfig.lookups, lookupsOldAndNewNumbers);
        }

        let variables = prepareVariables(missingVariables, this.props.reportConfig.variables, lookupsOldAndNewNumbers, mainVariable);

        let oldAndNewFunctionsNumbers = new Map<number, number>();

        let missingFunctions = copyArray(this.state.missingFunctions);

        let functions: UserDefinedFunction[] = [];

        if (missingFunctions.length) {
            functions = prepareFunctions(missingFunctions, this.props.reportConfig.userDefinedFunctions, oldAndNewFunctionsNumbers);
        }
        else {
            functions = copyArray(this.props.reportConfig.userDefinedFunctions);
        }

        let lookupsForUpdate = lookups.filter(x => this.state.missingLookups.map(x => x.id).includes(x.globalLookupModuleId || 0));

        lookupsForUpdate.forEach((l) => {
            updateLookupToLookupReferences(l, this.props.collections.globalModuleConfig, this.props.reportConfig);
            updateReportComponentToFunctionCondition(l.condition, functions);
        });

        let variablesForUpdate = variables.filter(x => missingVariables.map(x => x.id).includes(x.globalVariableModuleId || 0)).concat(mainVariable);

        variablesForUpdate.forEach(v => {
            updateReportComponentToFunctionAssignment(v.assignment, functions);
        });

        this.setState({ useGlobalData: false });

        lookups = lookups.concat(this.props.reportConfig.lookups);

        this.props.onAddGlobalReferencedVariables && this.props.onAddGlobalReferencedVariables(variables, lookups, refDataSources);
    }

    onGlobalVariableLinkClick(variableNumber: number) {

        let route = `${appRoutes.reporting.edit}?id=${this.props.collections.globalModuleConfig.id}&htmlid=${reportConfigNavigation.buildVariableId(variableNumber)}&section=${htmlIds.variables}` || '';

        window.open(route)?.focus();
    }

    onGlobalModeInPopupChange(selectedGlobalId: number | null) {

        let variable = this.props.collections.globalModuleConfig.variables.find(x => x.id === selectedGlobalId);

        this.setState({ isDataTypeSelectionDisabled: true, selecteDataType: variable?.dataType });
    }

    getDataTypeOptions() {
        return this.state.selecteDataType ? [dataTypeOptions.find(x => x.value === this.state.selecteDataType as string)] as SelectOption[] : dataTypeOptions;
    }

    validateDrag(dragNumber: number, dropNumber: number) {

        let draggedVariable = this.props.reportConfig.variables.find(v => v.number === dragNumber) as ReportVariable;
        let dropVariable = this.props.reportConfig.variables.find(v => v.number === dropNumber) as ReportVariable;

        let result = reportComponentBuildersHelper.validateDragAndDrop(draggedVariable as DragAndDropItem, dropVariable as DragAndDropItem, ComponentType.Variable);

        let changes = {} as ReportVariable;

        if (result.error) {
            const variableReferenced: ReportVariable = this.props.reportConfig.variables.find(s => s.number === result.number) || {} as ReportVariable;

            result.error = `${result.error} The referenced variable is "${variableReferenced.name}".`;

            changes.errors = [result.error];

            this.props.onDeclarationChange(this.getLocation(result.isDrag ? dragNumber : dropNumber), changes);

            return false;
        }

        return true;
    }

    onDropBetweenVariables(dragNumber: number, dropNumber: number) {

        let isDragValid = this.validateDrag(dragNumber, dropNumber)

        if (isDragValid) {
            let numbersMap = reorderHelper.prepareNewNumbersMapOnDragBetween(dragNumber, dropNumber);

            operandHelper.traverseReportConfigSectionsForOperands(this.props.reportConfig, (operand: Operand, itemName?: string, componentType?: ComponentType | undefined) => {
                if (componentType !== ComponentType.AccuracyValidation) {
                    if (operand.variableNumber && numbersMap.has(operand.variableNumber)) {
                        operand.variableNumber = numbersMap.get(operand.variableNumber) as number;
                    }
                }
            });

            this.props.onDragDeclarationBetween && this.props.onDragDeclarationBetween(numbersMap);
        }
    }

    onReferenceSelected(option: CustomDropdownOption) {
        if (option.asUrl && this.props.reportConfig.type === reportType.globalModule) {

            let type = prepareComponentType(option.component.componentType);

            onGlobalComponentLinkClick(option.component.componentNumber, type, option.component.reportConfigId || 0, option.component.componentInnerType, option.component.mainComponentNumber);
        }
        else {
            onReferenceSelected(option.component.htmlId || '');
        }
    }

    onGlobalVariableModeClick(globalVariableId: number) {

        let variableNumber = this.props.collections.globalModuleConfig.variables.find(x => x.id === globalVariableId)?.number as number;

        this.onGlobalVariableLinkClick(variableNumber);
    }

    onSearchInPaging(options: NameAndNumber[]) {

        if (this.props.reportConfig.type === reportType.accuracy) {

            let items = options?.[0]?.number ? copyArray([this.props.reportConfig.variables.find(x => x.number === options?.[0]?.number)]) as ReportVariable[] : [];

            this.setState({ items, refresh: true });
        }
        else {
            domNavigationHelper.navigate(reportConfigNavigation.buildVariableId(options?.[0].number || 0))
        }
    }

    onSearchBySelected(value: string) {

        if (value === SearchByType.Id) {
            this.setState({ searchBy: value });
        }

        if (value === SearchByType.Name) {
            this.setState({ searchBy: value });
        }
    }

    render(): JSX.Element {

        const dropdownOptions = prepareOptionsFromVariables(this.props.reportConfig.variables);

        return (
            <>
                {!this.props.isReadOnly &&
                    <SearchByFor
                        onSearchByChange={this.onSearchBySelected}
                        getOptions={() => this.props.reportConfig.variables.map((x) => { return { name: this.state.searchBy === SearchByType.Id ? x.number.toString() : x.name, number: x.number } }) as NameAndNumber[]}
                        searchByOptions={['Id', 'Name']}
                        onClearClick={() => this.setState({ items: this.props.reportConfig.variables })}
                        onSearch={(options: NameAndNumber[]) => this.onSearchInPaging(options)}
                    />
                }
                {this.props.reportConfig.type === reportType.accuracy ?
                    <ReportLogicListWithPaging
                        navigateTo={this.state.navigateTo}
                        isPagingUpdate={this.state.refresh}
                        onDropZoneDrop={this.onDropBetweenVariables}
                        isWaiting={this.props.isWaiting}
                        items={this.state.items}
                        columns={getColumns(
                            this.tryLock,
                            this.onNameChange,
                            this.onDataTypeChangeClick,
                            this.onBusinessDescriptionChange,
                            this.onIsSystemChange,
                            this.onRemoveVariableClick,
                            this.onCopyVariableClick,
                            this.getVariableReferences,
                            this.reorder,
                            this.props.reportConfig.type,
                            this.props.isReadOnly,
                            this.onReferenceSelected,
                            this.onGlobalVariableModeClick,
                            this.props.reportConfig.id as number)}
                        getContent={(item) => {
                            return this.getAssignmentContent(item);
                        }}
                        getKey={v => v.number}
                        createHtmlId={v => reportConfigNavigation.buildVariableId(v.number)}
                        onClick={(e: React.MouseEvent<HTMLElement>, item: ReportVariable) => {
                            if (item.isLocked && item.isReadOnly) {
                                this.tryLock(item.number);
                            }
                        }} />
                    :
                    <ReportLogicList
                        onDropZoneDrop={this.onDropBetweenVariables}
                        isWaiting={this.props.isWaiting}
                        items={this.props.reportConfig.variables}
                        columns={getColumns(
                            this.tryLock,
                            this.onNameChange,
                            this.onDataTypeChangeClick,
                            this.onBusinessDescriptionChange,
                            this.onIsSystemChange,
                            this.onRemoveVariableClick,
                            this.onCopyVariableClick,
                            this.getVariableReferences,
                            this.reorder,
                            this.props.reportConfig.type,
                            this.props.isReadOnly,
                            this.onReferenceSelected,
                            this.onGlobalVariableLinkClick,
                            this.props.reportConfig.id as number)}
                        getContent={(item) => {
                            return this.getAssignmentContent(item);
                        }}
                        getKey={v => v.number}
                        createHtmlId={v => reportConfigNavigation.buildVariableId(v.number)}
                        onClick={(e: React.MouseEvent<HTMLElement>, item: ReportVariable) => {
                            if (item.isLocked && item.isReadOnly) {
                                this.tryLock(item.number);
                            }
                        }} />
                }
                {
                    !this.props.isReadOnly &&
                    !this.props.isWaiting &&
                    <div className="mt-4 mb-4">
                        <button onClick={this.onAddVariableClick} className="btn btn-light">+ Variable</button>
                    </div>
                }
                {this.state.showInsertAtPositionModal ?
                    <AddComponentWithGlobalOptionsPopup
                        reportConfig={this.props.reportConfig}
                        onConfiguredInPopup={this.onVariableConfiguredInPopup}
                        getGlobalOptions={() => prepareOptionsFromGlobalVariables(
                            this.props.collections.globalModuleConfig?.variables,
                            this.props.reportConfig.rawDataSourceId as number,
                            this.props.reportConfig.variables,
                            this.props.collections.dataSources)
                        }
                        dropdownOptions={dropdownOptions}
                        onClose={() => this.setState({ showInsertAtPositionModal: false })}
                        title='New Variable'
                        dropdownTypeName='Data Type'
                        componentType={ComponentType.Variable}
                        components={this.props.reportConfig.variables as IdNameAndNumber[]}
                        dataTypeOtions={this.getDataTypeOptions()}
                        refreshGlobalOptionsOnDataTypeChange
                        onGlobalOptionChange={this.onGlobalModeInPopupChange}
                        globalCollection={(this.props.collections.globalModuleConfig.variables.map((x) => { return { id: x.id, type: x.dataType } as IdAndType }) as IdAndType[])}
                    />
                    : null
                }
                {this.state.showWarningModal &&
                    <WarningModal
                        onOkClick={this.state.onWarningOkClickFunction}
                        onCancelClick={() => this.setState({ showWarningModal: false })}
                        title={this.state.title}
                        message={this.state.message} />
                }
                {this.state.showGlobalVariableReferencesPopup &&
                    <WarningModal
                        message={this.state.globalVariableWarningMessage}
                        onOkClick={() => { this.setState({ showGlobalVariableReferencesPopup: false }); this.addDataSourcesAndMissingComponents(); }}
                        title='Global variable references'
                    />
                }
            </>
        );
    }
}

export default VariableBuilder;